import { PartyData } from 'models/PartyModel';
import Api from 'utils/api';


const useParties = () => {
    const createParty = (parentType: string, parentId: number, party: PartyData) => Api.parties.create(party)
        .then(res => Api.parties.attach(parentType, parentId, res.data.data.id));

    return {
        createParty,
        getParties: Api.parties.all,
        findParty: Api.parties.search,
        updateParty: Api.parties.update,
        attachParty: Api.parties.attach,
        detachParty: Api.parties.detach,
        setPartyType: Api.parties.setType,
        mergeParty: Api.parties.merge,
    }
};

export default useParties;
